
import { getFirestore, collection, query, orderBy, limit, getDocs, doc, updateDoc, deleteDoc } from "firebase/firestore";
import { app } from "../../firebase-config.js";

const db = getFirestore(app);

export const AdminReportsPage = async () => {
    const container = document.createElement('div');
    container.className = "max-w-5xl mx-auto px-4 py-8 pb-32";

    container.innerHTML = `
        <div class="mb-8 flex items-center justify-between">
            <h1 class="text-2xl font-bold text-gray-900 flex items-center gap-2">
                <span class="material-symbols-outlined text-red-600">report</span>
                신고 관리 센터
            </h1>
            <button id="btn-refresh" class="text-sm text-gray-500 hover:text-gray-800 flex items-center gap-1">
                <span class="material-symbols-outlined text-[16px]">refresh</span> 새로고침
            </button>
        </div>

        <div class="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
            <div class="overflow-x-auto">
                <table class="w-full text-left border-collapse">
                    <thead>
                        <tr class="bg-gray-50 border-b border-gray-200 text-xs text-gray-500 uppercase">
                            <th class="px-6 py-3 font-semibold">상태</th>
                            <th class="px-6 py-3 font-semibold">분류</th>
                            <th class="px-6 py-3 font-semibold">내용</th>
                            <th class="px-6 py-3 font-semibold">신고자</th>
                            <th class="px-6 py-3 font-semibold">접수일</th>
                            <th class="px-6 py-3 font-semibold text-right">관리</th>
                        </tr>
                    </thead>
                    <tbody id="report-list" class="divide-y divide-gray-100 text-sm">
                        <tr>
                            <td colspan="6" class="px-6 py-10 text-center text-gray-400">
                                <span class="loader-spin inline-block w-5 h-5 border-gray-300 border-t-blue-500"></span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    `;

    const listContainer = container.querySelector('#report-list');
    const btnRefresh = container.querySelector('#btn-refresh');

    const loadReports = async () => {
        listContainer.innerHTML = '<tr><td colspan="6" class="px-6 py-10 text-center text-gray-400">로딩 중...</td></tr>';

        try {
            const q = query(collection(db, 'reports'), orderBy('createdAt', 'desc'), limit(50));
            const snapshot = await getDocs(q);

            if (snapshot.empty) {
                listContainer.innerHTML = '<tr><td colspan="6" class="px-6 py-10 text-center text-gray-400">접수된 신고가 없습니다.</td></tr>';
                return;
            }

            listContainer.innerHTML = '';

            snapshot.forEach(docSnap => {
                const data = docSnap.data();
                const tr = document.createElement('tr');
                tr.className = "hover:bg-gray-50 transition-colors";

                const statusColor = data.status === 'resolved' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700';
                const statusLabel = data.status === 'resolved' ? '처리완료' : '접수대기';

                tr.innerHTML = `
                    <td class="px-6 py-4">
                        <span class="px-2 py-1 rounded-full text-[10px] font-bold ${statusColor}">${statusLabel}</span>
                    </td>
                    <td class="px-6 py-4 font-medium text-gray-700 uppercase">${data.category}</td>
                    <td class="px-6 py-4">
                        <div class="line-clamp-2 text-gray-600 max-w-xs" title="${data.content}">${data.content}</div>
                        ${data.url ? `<a href="${data.url}" target="_blank" class="text-xs text-blue-400 hover:underline block mt-1">관련 링크</a>` : ''}
                    </td>
                    <td class="px-6 py-4 text-gray-500">
                        <div>${data.userEmail}</div>
                        <div class="text-[10px] text-gray-400">${data.userId}</div>
                    </td>
                    <td class="px-6 py-4 text-gray-500 whitespace-nowrap">
                        ${data.createdAt ? new Date(data.createdAt.seconds * 1000).toLocaleDateString() : '-'}
                    </td>
                    <td class="px-6 py-4 text-right">
                        ${data.status !== 'resolved' ? `
                            <button id="btn-resolve-${docSnap.id}" class="text-blue-600 hover:text-blue-800 text-xs font-bold mr-2">완료 처리</button>
                        ` : ''}
                        <button id="btn-delete-${docSnap.id}" class="text-gray-400 hover:text-red-500 text-xs">삭제</button>
                    </td>
                `;

                // Actions
                const btnResolve = tr.querySelector(`#btn-resolve-${docSnap.id}`);
                if (btnResolve) {
                    btnResolve.onclick = async () => {
                        if (confirm('이 신고를 처리 완료로 변경하시겠습니까?')) {
                            await updateDoc(doc(db, 'reports', docSnap.id), { status: 'resolved' });
                            loadReports();
                        }
                    };
                }

                const btnDelete = tr.querySelector(`#btn-delete-${docSnap.id}`);
                if (btnDelete) {
                    btnDelete.onclick = async () => {
                        if (confirm('정말 삭제하시겠습니까?')) {
                            await deleteDoc(doc(db, 'reports', docSnap.id));
                            loadReports();
                        }
                    };
                }

                listContainer.appendChild(tr);
            });

        } catch (e) {
            console.error(e);
            listContainer.innerHTML = '<tr><td colspan="6" class="px-6 py-10 text-center text-red-400">데이터 로드 실패</td></tr>';
        }
    };

    btnRefresh.onclick = loadReports;
    loadReports();

    return container;
};
